const SELECTORS = {
    switchButton: '.wp-block-ssm-interactive-map__toggle-view',
};

const CLASSES = {
    viewGrid: 'is-view-grid',
    viewMap: 'is-view-map',
};

const STORAGE_KEY = 'map_view_preference';

export class ViewToggle {
    constructor(block) {
        this.block = block;
        this.currentView = 'grid';

        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);

        this.init();
    }

    init() {
        this.cacheDOM();
        if (!this.switchButton) return;

        this.bindEvents();
        this.setInitialView();
    }

    cacheDOM() {
        this.switchButton = this.block.querySelector(SELECTORS.switchButton);
        this.mapIcon = this.switchButton?.querySelector('div:first-child');
        this.gridIcon = this.switchButton?.querySelector('div:last-child');
    }

    bindEvents() {
        this.switchButton.addEventListener('click', this.handleClick);
        this.switchButton.addEventListener('keydown', this.handleKeydown);
    }

    handleClick() {
        this.toggleView();
    }

    handleKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.toggleView();
        }
    }

    setInitialView() {
        const urlParams = new URLSearchParams(window.location.search);
        const urlView = urlParams.get('view');

        // URL parameter takes priority over localStorage
        if (urlView === 'map') {
            this.switchToMap();
            this.scrollToBlock();

            return;
        }

        if (urlView === 'grid') {
            this.switchToGrid();
            this.scrollToBlock();

            return;
        }

        // Fall back to localStorage only if no URL parameter
        const savedView = localStorage.getItem(STORAGE_KEY);
        if (savedView === 'map') {
            this.switchToMap();
        } else {
            this.switchToGrid();
        }
    }

    scrollToBlock() {
        // Small delay to ensure layout is complete
        requestAnimationFrame(() => {
            this.block.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    toggleView() {
        if (this.currentView === 'grid') {
            this.switchToMap();
        } else {
            this.switchToGrid();
        }
    }

    switchToGrid() {
        this.currentView = 'grid';

        this.block.classList.remove(CLASSES.viewMap);
        this.block.classList.add(CLASSES.viewGrid);

        this.mapIcon.classList.remove('hidden');
        this.gridIcon.classList.add('hidden');

        this.switchButton.setAttribute('aria-label', 'Switch to map view');

        localStorage.setItem(STORAGE_KEY, 'grid');
        this.updateURL('grid');
    }

    switchToMap() {
        this.currentView = 'map';

        this.block.classList.remove(CLASSES.viewGrid);
        this.block.classList.add(CLASSES.viewMap);

        this.mapIcon.classList.add('hidden');
        this.gridIcon.classList.remove('hidden');

        this.switchButton.setAttribute('aria-label', 'Switch to grid view');

        localStorage.setItem(STORAGE_KEY, 'map');
        this.updateURL('map');
    }

    updateURL(view) {
        if (window.wp?.data) return;
        const url = new URL(window.location);

        // Only keep the view parameter for the map view; remove it otherwise.
        if (view === 'map') {
            url.searchParams.set('view', view);
        } else {
            url.searchParams.delete('view');
        }

        window.history.replaceState({}, '', url);
    }

    destroy() {
        if (this.switchButton) {
            this.switchButton.removeEventListener('click', this.handleClick);
            this.switchButton.removeEventListener('keydown', this.handleKeydown);
        }
    }
}
